import React, { FC, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router";

import { useThemingPrefix } from "hooks/useThemingPrefix";

import { useOnClickOutside } from "../../../hooks/use-onclick-outside";
import chevronSvg from "../../../resources/icons/chevronDown.svg";
import { getRoute, pages } from "../../../utils/routrer-utils";

//import { useGetParksQuery } from "../../../store/api/park.api";

import { useGetUserQuery } from "../../../store/api/user.api";

import { useAuth } from "../../../utils/user-provider";

import { SubTabItem, TabMenuList } from "./tab-menu.type";
import styles from "./tab-menu.module.css";

type TabsMenuProps = {
  isShow: boolean;
};

const TabMenu: FC<TabsMenuProps> = (props) => {
  const userQuery = useGetUserQuery("");
  const vendorThemingPrefix = useThemingPrefix();
  // const { data = [] } = useGetParksQuery("");
  const { logout } = useAuth();
  const { isShow } = props;
  const [activeTab, changeActiveTab] = useState(null);
  const location = useLocation();
  const submenuRef = useRef(null);
  //const menuParksList = data.map((park) => ({
  //  title: `Skypark ${park.name}`,
  //  link: `${pages.VIDEOS}/${park.id}`,
  //}));
  const menuList: TabMenuList = [
    {
      title: "Мои видео",
      link: pages.VIDEOS,
    },
    {
      title: "Помощь",
      link: pages.HELP,
    },
    {
      title: "Контакты",
      link: pages.CONTRACTS,
    },
    {
      title: "Аккаунт",
      link: "/account",
      isRight: true,
      submenu: [
        {
          title: `Добро пожаловать, ${
            userQuery.data?.name || "Временный пользователь"
          }`,
          link: pages.SETTINGS,
          withAuth: true,
        },
        {
          title: "Настройки аккаунта",
          link: pages.SETTINGS,
          withAuth: true,
        },
        // Ссылки отключены по ТЗ
        // {
        //   title: "Войти",
        //   link: "/",
        // },
        // {
        //   title: "Регистрация",
        //   link: "/",
        // },
        {
          title: "Выйти",
          withAuth: true,
          link: () => logout(),
        },
      ],
    },
  ];
  useOnClickOutside(submenuRef, changeActiveTab.bind(null, null));

  if (!isShow) return <></>;

  const renderSubmenu = (submenu: Array<SubTabItem>, isRight: boolean) => (
    <ul
      ref={submenuRef}
      className={isRight ? styles.tabSubMenuRight : styles.tabSubMenu}
    >
      {submenu.map((item, index) =>
        typeof item.link === "function" ? (
          <li key={index} className={styles.itemSubMenu} onClick={item.link}>
            {item.title}
          </li>
        ) : (
          <NavLink
            key={index}
            className="block"
            to={getRoute(item.link, vendorThemingPrefix)}
          >
            <li
              className={
                item.link === location.pathname
                  ? styles.itemSubMenuActive
                  : styles.itemSubMenu
              }
            >
              {item.title}
            </li>
          </NavLink>
        )
      )}
    </ul>
  );

  const renderTabMenu = () => (
    <>
      <ul className={styles.tabMenu}>
        {menuList.map((item, index) => {
          const subMenu =
            item.submenu && activeTab === index ? (
              renderSubmenu(item.submenu, item.isRight)
            ) : (
              <></>
            );
          return (
            <li
              key={index}
              className={styles.itemTabMenu}
              onClick={changeActiveTab.bind(null, index)}
            >
              <div className={styles.flexContainer}>
                <div className={styles.flexItems}>
                  {location.pathname.includes(item?.link) && (
                    <div className={styles.itemTabActive} />
                  )}
                  {item.submenu ? (
                    item.title
                  ) : (
                    <NavLink to={getRoute(item.link, vendorThemingPrefix)}>
                      {item.title}
                    </NavLink>
                  )}
                </div>
                {item.submenu && (
                  <img
                    src={chevronSvg}
                    className={styles.chevronIcon}
                    alt="chevron"
                  />
                )}
              </div>
              {subMenu}
            </li>
          );
        })}
      </ul>
    </>
  );
  return <>{renderTabMenu()}</>;
};

export default TabMenu;
